<template>
  <OuterCasing class="main scroll-touch">
    {{ /* vue-router 绑定过渡 */ }}
    <!-- <transition name="vue-router-fade"> -->
      <router-view />
    <!-- </transition> -->
  </OuterCasing>
</template>

<script>
import OuterCasing from '$common/components/component-outer-casing';
import WechatJssdk from '$common/utils/wechat/web-jssdk';
//  预留的外层壳，以防要加点什么没预留后路
export default {
  components: { OuterCasing },
  created() {
    WechatJssdk.config()?.then(res => WechatJssdk?.share());
  }
}
</script>